import { useState, useEffect } from "react";

/**
 * @function
 * @template T
 * @param {string} keyName
 * @param {T} defaultValue
 * @returns {[T, (_: T) => void]}
 */
export const useLocalStorage = (keyName, defaultValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(keyName);
      if (value) {
        return JSON.parse(value);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch {
      return defaultValue;
    }
  });

  // Update storedValue when localStorage changes from another tab
  useEffect(() => {
    const setValue = (/** @type {any} */ newValue) => {
      try {
        window.localStorage.setItem(keyName, JSON.stringify(newValue));
      } catch (err) {
        console.log(err);
      }
    };
    setValue(storedValue);
  }, [storedValue]);

  return [storedValue, setStoredValue];
};
